<template>
  <div class="row h-100">
    <d-3-bar-chart
      :data="weekData"
      :dataRange="dataRange"
      :tag="referenceTag"
      :trendData="linearRegData"
      :activeChart="activeChart"
      :trendLine="trendLine"
      :anomaly="anomaly"
      :title="title"
    />
  </div>
</template>

<script>
import D3BarChart from "./d3-barchart.vue";

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export default {
  props: {
    oneWeekData: Array,
    dataRange: Number,
    tag: String,
    referenceTag: String,
    linearReg: Array,
    trendLine: Boolean,
    anomaly: Array,
    title: String,
  },

  components: {
    D3BarChart,
  },
  data() {
    return {
      showTrendLine: true,
      activeChart: 1
    };
  },
  methods: {
    codeRed(score) {
      return score < 0.75;
    },
    getDateString(day) {
      let date = new Date();
      date.setDate(date.getDate() - day);
      return monthNames[date.getMonth()] + " " + date.getDate();
    },
  },
  computed: {
    linearRegData() {
      let scores;
      if (this.linearReg) {
        scores = this.linearReg[0].map((vitalSign) => {
          // Define defaults

          let score = NaN;
          if (this.tag === "bloodPressure")
            score = { systolic: 0.0, diastolic: 0.0 };

          // Error handling
          if (!vitalSign) return score;
          // if (!this.tag || !vitalSign[this.tag]) return score;

          // Actual score calculation
          score = Math.min(vitalSign['y'] / this.dataRange, 1.0);
          if (this.tag === "bloodPressure") {
            score = {
              systolic: Math.min(parseFloat(vitalSign['systolic']['y']) / this.dataRange, 1.0),
              diastolic: Math.min(parseFloat(vitalSign['diastolic']['y']) / this.dataRange, 1.0)
            };
          }
          return score;
        });
      } else {
        scores = Array(7).fill(
          this.tag === "bloodPressure"
            ? { systolic: 0.0, diastolic: 0.0 }
            : 0.0
        );
      }

      return [6, 5, 4, 3, 2, 1, 0].map((day, index) => {
        let date = new Date();
        date.setDate(date.getDate() - day);

        return {
          date: date,
          score: scores[index],
        };
      });
    },
    weekData() {
      let scores;
      if (this.oneWeekData) {
        scores = this.oneWeekData.map((vitalSign) => {
          // Define defaults
          let score = NaN;
          if (this.tag === "bloodPressure")
            score = { systolic: NaN, diastolic: NaN };

          // Error handling
          if (!vitalSign) return score;
          if (!this.tag || !vitalSign[this.tag]) return score;

          // Actual score calculation
          score = Math.min(vitalSign[this.tag] / this.dataRange, 1.0);
          if (this.tag === "bloodPressure") {
            let sp = vitalSign[this.tag].split("/");
            let [systolic, diastolic] = sp;
            score = {
              systolic: Math.min(parseFloat(systolic) / this.dataRange, 1.0),
              diastolic: Math.min(parseFloat(diastolic) / this.dataRange, 1.0),
            };
          }
          return score;
        });
      } else {
        scores = Array(7).fill(
          this.tag === "bloodPressure"
            ? { systolic: 0.0, diastolic: 0.0 }
            : 0.0
        );
      }

      return [6, 5, 4, 3, 2, 1, 0].map((day, index) => {
        let date = new Date();
        date.setDate(date.getDate() - day);

        return {
          date: date,
          score: scores[index],
        };
      });
    },
  },
};
</script>

<style scoped>
.details-history-chart {
  --color: transparent;
}
.details-history-chart.column {
  height: 40vh;
  width: 100%;
  margin: 0 auto;
}
.details-history-chart > .data-axis {
  grid-area: data-axis;
  writing-mode: tb-rl;
  transform: rotateZ(180deg);
}
.details-history-bar {
  height: 100%;
  background: #c4c4c4;
  width: 20px;
}

.bar-tip {
  transform: translate(-8px, -50%);
}
.label {
  padding-top: 15px;
}
.y-axis {
  position: relative;
  right: 0px;
  width: 100%;
}
</style>
<style src="charts.css"></style>
